import { twMerge } from "tailwind-merge";

export type Props = {
  children: React.ReactNode;
  className?: string;
};

export function Badge({ children, className }: Props) {
  return (
    <div
      className={twMerge(
        "inline-flex items-center justify-center px-1.5 py-0.5 rounded-full border border-brand-800 text-brand-800 shadow-sm whitespace-nowrap",
        className
      )}
    >
      {children}
    </div>
  );
}

export default Badge;
